export const solutions = [
  {
    name: "AI Transformation",
    slug: "ai-transformation",
    icon: "BrainCircuit",
    tagline: "Move from AI experiments to governed, production-grade systems.",
    seo: "AI transformation consulting — generative AI, LLM applications, AI agents, MLOps and responsible AI to deliver measurable outcomes.",
    image: "https://images.pexels.com/photos/17485657/pexels-photo-17485657.png",
    problem:
      "Leaders know AI matters, but experiments rarely reach production and value is hard to prove.",
    approach:
      "AMVI helps you identify high-value use cases, build production-grade AI and generative AI systems, and put governance and MLOps in place so results are reliable and repeatable.",
    capabilities: [
      "Generative AI & LLM applications",
      "AI agents & automation",
      "MLOps & model governance",
      "Responsible AI & guardrails",
    ],
    outcomes: [
      "Faster time from pilot to production",
      "Governed, auditable AI systems",
      "Measurable ROI on AI investment",
    ],
    cta: "Start Your AI Journey",
  },
  {
    name: "Data Modernization",
    slug: "data-modernization",
    icon: "Database",
    tagline: "A trusted data foundation for real-time decisions.",
    seo: "Data modernization services — cloud data platforms, lakehouses, pipeline and warehouse modernization, real-time data and BI enablement.",
    image: "https://images.unsplash.com/photo-1606778303077-3780ea8d5420?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    problem:
      "Fragmented, slow and untrusted data prevents teams from making confident, real-time decisions.",
    approach:
      "We modernize your data foundation with cloud platforms, resilient pipelines and governed analytics so the whole organization can trust and act on data.",
    capabilities: [
      "Cloud data platforms & lakehouses",
      "Pipeline & warehouse modernization",
      "Real-time & streaming data",
      "Analytics & BI enablement",
    ],
    outcomes: [
      "Single source of trusted data",
      "Real-time analytics and reporting",
      "Self-service enabled safely",
    ],
    cta: "Modernize Your Data",
  },
  {
    name: "Cloud Transformation",
    slug: "cloud-transformation",
    icon: "Cloud",
    tagline: "Migrate and modernize on AWS, Azure and GCP — without the downtime.",
    seo: "Cloud transformation and migration consulting — cloud strategy, Kubernetes, DevOps, CI/CD and cost & reliability engineering.",
    image: "https://images.unsplash.com/photo-1775519520461-6b6e068d9250?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    problem:
      "Legacy infrastructure limits scale, raises cost and slows delivery across the business.",
    approach:
      "AMVI plans and executes cloud migration and modernization on AWS, Azure and GCP, with DevOps and reliability engineering baked in from day one.",
    capabilities: [
      "Cloud strategy & migration",
      "Kubernetes & container platforms",
      "DevOps & CI/CD automation",
      "Cloud cost & reliability engineering",
    ],
    outcomes: [
      "Zero / minimal-downtime migrations",
      "Lower infrastructure cost",
      "Faster, safer releases",
    ],
    cta: "Accelerate Your Cloud",
  },
  {
    name: "Application Modernization",
    slug: "application-modernization",
    icon: "AppWindow",
    tagline: "Turn aging applications into agile, cloud-native platforms.",
    seo: "Application modernization services — legacy modernization, microservices, APIs, systems integration and product engineering.",
    image: "https://images.unsplash.com/photo-1542744173-8e7e53415bb0?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    problem:
      "Aging applications are expensive to maintain and hard to extend with new capabilities.",
    approach:
      "We modernize applications with cloud-native architecture, microservices and APIs, reducing risk while unlocking new features and integrations.",
    capabilities: [
      "Legacy modernization",
      "Microservices & APIs",
      "Systems integration",
      "Product & UX engineering",
    ],
    outcomes: [
      "Lower maintenance cost",
      "Faster feature delivery",
      "Easier integration across systems",
    ],
    cta: "Modernize Your Applications",
  },
  {
    name: "Digital Engineering",
    slug: "digital-engineering",
    icon: "Cpu",
    tagline: "End-to-end engineering, from embedded to automation.",
    seo: "Digital engineering services — product and software engineering, embedded and semiconductor engineering, automation and quality engineering.",
    image: "https://images.unsplash.com/photo-1716191299980-a6e8827ba10b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    problem:
      "Engineering initiatives stall without deep, specialized technical capability and delivery capacity.",
    approach:
      "AMVI provides end-to-end digital engineering — from embedded and product engineering to automation — supported by specialized talent.",
    capabilities: [
      "Product & software engineering",
      "Embedded & semiconductor engineering",
      "Automation & digital twins",
      "Quality & test engineering",
    ],
    outcomes: [
      "Accelerated engineering roadmaps",
      "Access to specialized expertise",
      "Higher quality and reliability",
    ],
    cta: "Scale Your Engineering",
  },
  {
    name: "Workforce Transformation",
    slug: "workforce-transformation",
    icon: "Users",
    tagline: "Build high-performing technical teams, fast and flexibly.",
    seo: "Workforce transformation and technology staffing — contract, direct hire, contract-to-hire, dedicated teams and engineering staffing in the USA.",
    image: "https://images.unsplash.com/photo-1622675363311-3e1904dc1885?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    problem:
      "Organizations struggle to scale teams with the right specialized talent at the right time.",
    approach:
      "We provide flexible talent models — contract, direct hire, contract-to-hire and dedicated teams — to help you build high-performing technical teams fast.",
    capabilities: [
      "Contract & contract-to-hire staffing",
      "Direct hire & recruiting",
      "Dedicated & offshore teams",
      "Engineering & semiconductor staffing",
    ],
    outcomes: [
      "Critical roles filled faster",
      "Flexible capacity as needs change",
      "Access to specialized talent pools",
    ],
    cta: "Transform Your Workforce",
  },
];

export const getSolution = (slug) => solutions.find((s) => s.slug === slug);
